/********************************************************************
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this 
 * file in accordance with the terms of the Adobe license agreement 
 * accompanying it. 
 *******************************************************************/

export const RECAPTCHA_CONFIGURATION_V3 = `query {
  recaptchaV3Config {
    is_enabled
    website_key
    minimum_score
    badge_position
    language_code
    failure_message
    forms
    theme
  } 
}`;
